import { useState } from "react";
// import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const [formData, setFormData] = useState({ phone_number: "", email: "" });
  let [OTP, setOTP] = useState(100);
  let [isOTPVerified, setisOTPVerified] = useState(true);
  let [password, setPassword] = useState("");
  let [isValid, setIsValid] = useState(false);
  let [isPasswordMatching, setIsPasswordMatching] = useState(true);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // const navigate = useNavigate();

  const sendOTP = (e) => {
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}sendOTP`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setOTP(data.OTP);
        } else {
          alert("Invalid Details!");
        }
      })
      .catch(() => {
        alert("Something Went wrong!");
      });
  };

  // const changePassword = (e) => {
  //   e.preventDefault();
  //   fetch(`${process.env.REACT_APP_API_URL}changePassword`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     credentials: "include",
  //     body: JSON.stringify({ ...formData, password }),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (data.status === "success") {
  //         navigate(process.env.PUBLIC_URL);
  //       } else {
  //         alert("Something Went wrong!");
  //       }
  //     })
  //     .catch(() => {
  //       alert("Something Went wrong!");
  //     });
  // };

  const verifyOTP = (e) => {
    if (Number(e.target.value) === OTP) {
      setisOTPVerified(true);
    } else {
      setisOTPVerified(false);
    }
  };

  const checkPasswordRequirement = (e) => {
    let password = e.target.value;
    let passwordRegex = /^(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.*[a-zA-Z]).{8,}$/;
    setPassword(password);
    if (passwordRegex.test(password)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const verifyPassword = (e) => {
    if (e.target.value === password) {
      setIsPasswordMatching(true);
    } else {
      setIsPasswordMatching(false);
    }
  };

  const resetPassword = () => {};

  return (
    <div className="container mt-4">
      {OTP === null ? (
        <div className="card shadow p-4 col-md-6 mx-auto">
          <h2 className="text-center">Forgot Password</h2>
          <form onSubmit={sendOTP} className="py-4">
            <div className="mb-3">
              <label className="form-label">Enter Phone Number</label>
              <input
                type="text"
                name="phone_number"
                className="form-control"
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Enter Email ID</label>
              <input
                type="email"
                name="email"
                className="form-control"
                onChange={handleChange}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Get OTP
            </button>
          </form>
        </div>
      ) : isOTPVerified === false ? (
        <div className="card shadow p-4 col-md-6 mx-auto">
          <h2 className="text-center">Verify OTP</h2>
          {/* <form onSubmit={verifyOTP} className="py-4"> */}
          <div className="mb-3">
            <label className="form-label">Enter OTP</label>
            <input
              type="number"
              name="otp"
              className="form-control"
              onChange={verifyOTP}
            />
          </div>
        </div>
      ) : (
        <div className="card shadow p-4 col-md-6 mx-auto">
          <h2 className="text-center">Reset Password</h2>
          <form onSubmit={resetPassword} className="py-4">
            <div className="mb-3">
              <label className="form-label">Enter New Password</label>
              <input
                type="password"
                name="password"
                className="form-control"
                onBlur={checkPasswordRequirement}
              />
              {password.length > 0 && (
                <p style={{ color: isValid ? "green" : "red" }}>
                  {isValid
                    ? "Password is strong and meets all requirements."
                    : "Password must be at least 8 characters long and include one uppercase letter, one lowercase letter, one number, and one special character."}
                </p>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">Confirm Password</label>
              <input
                type="password"
                name="cnfm_password"
                className="form-control"
                onBlur={verifyPassword}
              />
              {!isPasswordMatching && (
                <p style={{ color: "red" }}>Passwords are not matching</p>
              )}
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={(!isPasswordMatching || !isValid) && "true"}
            >
              Submit
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
